import { render, staticRenderFns } from "./ComSalesIndex.vue?vue&type=template&id=ee0a9ea8&scoped=true"
import script from "./ComSalesIndex.vue?vue&type=script&lang=js"
export * from "./ComSalesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a9ea8",
  null
  
)

export default component.exports